import { type User as Auth0User, useAuth0 } from '@auth0/auth0-react';

export interface AuthUser extends Auth0User {
  sub: string;
  email: string;
  name: string;
}

export interface UseAuthReturn {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: AuthUser | undefined;
  login: (returnTo?: string) => void;
  logout: (returnTo?: string) => void;
  getAccessToken: () => Promise<string>;
}

export function useAuth(): UseAuthReturn {
  const { isAuthenticated, isLoading, user, loginWithRedirect, logout, getAccessTokenSilently } =
    useAuth0();

  return {
    isAuthenticated,
    isLoading,
    user: user as AuthUser | undefined,
    login: (returnTo?: string) =>
      void loginWithRedirect(returnTo !== undefined ? { appState: { returnTo } } : {}),
    logout: (returnTo?: string) =>
      void logout({
        logoutParams: { returnTo: returnTo ?? window.location.origin },
      }),
    getAccessToken: () => getAccessTokenSilently(),
  };
}

export function useUser(): AuthUser | undefined {
  const { user } = useAuth();
  return user;
}
